import React from 'react';

const NotificationItem = ({ notification }) => {
    const { icon, image, title } = notification;
    return (

        <li className="media">
            <img
                alt={image}
                src={image}
                className="avatar-sm rounded-circle mr-2 rounded-circle"
            />
            <span className="media-body align-self-center">
                <i className={`zmdi ${icon} zmdi-hc-fw d-inline-block`} />
                <p className="sub-heading mb-0 d-inline-block">{title}</p>
            </span>
        </li>
    );
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./components/AppNotification/NotificationItem.js